/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-kno2
 * Kno2 Document Fetcher API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Kno2Execution } from './Kno2Execution';
import {
    Kno2ExecutionFromJSON,
    Kno2ExecutionFromJSONTyped,
    Kno2ExecutionToJSON,
} from './Kno2Execution';

/**
 * 
 * @export
 * @interface TriggerDocumentFetcher201Response
 */
export interface TriggerDocumentFetcher201Response {
    /**
     * 
     * @type {Kno2Execution}
     * @memberof TriggerDocumentFetcher201Response
     */
    data?: Kno2Execution;
}

/**
 * Check if a given object implements the TriggerDocumentFetcher201Response interface.
 */
export function instanceOfTriggerDocumentFetcher201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TriggerDocumentFetcher201ResponseFromJSON(json: any): TriggerDocumentFetcher201Response {
    return TriggerDocumentFetcher201ResponseFromJSONTyped(json, false);
}

export function TriggerDocumentFetcher201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerDocumentFetcher201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : Kno2ExecutionFromJSON(json['data']),
    };
}

export function TriggerDocumentFetcher201ResponseToJSON(value?: TriggerDocumentFetcher201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': Kno2ExecutionToJSON(value.data),
    };
}

